export const getUrlParameter = (name: string) => {
  const parameters = new URLSearchParams(document.location.search);

  return parameters.get(name);
};
